import React from 'react';
import { Row, Col, Layout, Card, Typography, Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import RecentQueries from './RecentQueries';
import BackLink from '../BackLink';
import QuerySearchAutocomplete from './QuerySearchAutocomplete';
import NewQuestionButton from './NewQuestionButton';

const { Content } = Layout;
const { Title, Text } = Typography;

const QueryDetailsFailedLoading = ({ uuid, query }) => {
  const { t } = useTranslation();
  
  return (
    <Content className="page">
      <Row gutter={[32, 32]}>
        {/* Mobile Back Link */}
        <Col xs={24} md={0}>
          <BackLink to='/queries/new' preventHistory={true} />
        </Col>

        {/* Sidebar: Search + Recent Queries */}
        <Col xs={24} md={8} lg={8}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <QuerySearchAutocomplete/>
            <NewQuestionButton />
          </div>
          <RecentQueries
            activeQueryUuid={uuid}
            reloadTrigger={0}
          />
        </Col>

        {/* Failed Loading Content */}
        <Col xs={24} md={16} lg={16}>
          <Card style={{ paddingBottom: '20px' }}>
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{ marginBottom: '20px' }}>
                <InfoCircleOutlined style={{ fontSize: '3em', color: '#1890ff' }} />
              </div>
              <Title level={3} style={{ color: '#666' }}>
                {t('query_details.deep_research_failed.title')}
              </Title>
            </div>
            <div>
            <Text style={{ fontSize: '16px', color: '#666', marginBottom: '20px', display: 'block' }}>
              {t('query_details.deep_research_failed.subtitle')}
            </Text>
              
            <Alert
              message={t('query_details.deep_research_failed.quota_message')}
              type="info"
              style={{ marginTop: '20px', textAlign: 'left' }}
            />
            </div>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default QueryDetailsFailedLoading; 